import "../../css/Buttons/RectangleButtonStyles.css";
import React, { useMemo } from "react";
import { Icon } from "@iconify/react";
import { Colors } from "../../utils/colors";
import { DarkTheme, ThemeStyle } from "../../hooks/useTheme";

type SlidingToggleButtonProps<T extends string> = {
  currentValue: T;
  onToggle: (value: T) => void;
  leftOption: {
    value: T;
    icon: string;
  };
  rightOption: {
    value: T;
    icon: string;
  };
  containerStyles?: React.CSSProperties;
  theme?: ThemeStyle;
};

const SlidingToggleButton = <T extends string>(
  props: SlidingToggleButtonProps<T>
) => {
  const {
    currentValue,
    onToggle,
    leftOption,
    rightOption,
    containerStyles,
    theme,
  } = props;

  const isDarkTheme = useMemo(() => theme && theme === DarkTheme, [theme]);

  const styles = {
    buttonContainer: {
      backgroundColor: isDarkTheme ? Colors.GRAY10 : Colors.WHITE1,
      minHeight: 36,
      borderRadius: 12,
    },
    toggleContainer: {
      zIndex: 2,
      cursor: "pointer",
    },
  };

  return (
    <div
      className="AlignedRowSelect"
      style={{
        ...styles.buttonContainer,
        position: "relative",
        zIndex: 1,
        ...containerStyles,
      }}
    >
      <div
        style={{
          ...styles.toggleContainer,
          padding: "5px 7px 5px 10px",
        }}
        onClick={() => onToggle(leftOption.value)}
      >
        <Icon
          icon={leftOption.icon}
          height={16}
          style={{
            color:
              currentValue === leftOption.value
                ? isDarkTheme
                  ? Colors.WHITE
                  : Colors.BLACK
                : Colors.GRAY3,
          }}
        />
      </div>
      <div
        style={{
          ...styles.toggleContainer,
          padding: "5px 10px 5px 7px",
        }}
        onClick={() => onToggle(rightOption.value)}
      >
        <Icon
          icon={rightOption.icon}
          height={16}
          style={{
            color:
              currentValue === rightOption.value
                ? isDarkTheme
                  ? Colors.WHITE
                  : Colors.BLACK
                : Colors.GRAY3,
          }}
        />
      </div>
      <div
        style={{
          zIndex: 1,
          backgroundColor:
            theme && theme === DarkTheme ? Colors.GRAY7 : Colors.WHITE,
          borderRadius: 10,
          boxSizing: "border-box",
          boxShadow: "0px 0px 1px 0px #929292",
          position: "absolute",
          padding: 15,
          display: "block",
          left: `calc(${currentValue === leftOption.value ? "5%" : "50%"})`,
          transitionDuration: "0.3s",
          transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
          transitionBehavior: "normal",
        }}
      ></div>
    </div>
  );
};

export default SlidingToggleButton;
